import { render, staticRenderFns } from "./PollOverview.vue?vue&type=template&id=674e0166&scoped=true&"
import script from "./PollOverview.vue?vue&type=script&lang=js&"
export * from "./PollOverview.vue?vue&type=script&lang=js&"
import style0 from "./PollOverview.vue?vue&type=style&index=0&id=674e0166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674e0166",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VDivider,VIcon,VRow,VTooltip})
